import { useAuthContext } from '../context/AuthContext';

export default function useAuth() {
  const { token, setToken, user, setUser, currentBranch, selectBranch } = useAuthContext();

  const login = (newToken, newUser) => {
    setToken(newToken);
    setUser(newUser);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    selectBranch(null);
  };

  return { token, user, currentBranch, login, logout, selectBranch };
}
